import { callStorage } from '../../safe_utils/src/safe_storage.js';
import { decodeJwt, isTokenExpired } from './jwt_core.js';

/**
 * Helpers for dealing with the JWT stored in localStorage.
 */
/**
***Changes**:
*- Updated import path for `InputProps` to `../../types/interfaces`.
*
*3. **Token Utilities** (`src/functions/auth/token_utils.ts`):
*   Copy from `/var/www/abstractendeavors/my-login-app/src/functions/auth_utils/token_utils.ts`.
*
*/
/** Read raw JWT from LocalStorage (or null if absent) */
function getToken() {
    return callStorage('getItem', 'token');
}
function isLoggedIn() {
    const tok = getToken();
    return !!tok && !isTokenExpired(tok ?? "");
}
/**
 * Add a Bearer Authorization header.
 * A shallow copy of headers is returned so callers can keep chaining.
 */
function getAuthorizationHeader(headers = {}, token = null) {
    token = token ?? getToken();
    headers = headers || {};
    if (token)
        headers["Authorization"] = `Bearer ${token}`;
    return { ...headers };
}
/** Throw + redirect if there’s no valid token; otherwise return it. */
function requireToken() {
    const tok = getToken();
    if (!tok || isTokenExpired(tok)) {
        console.warn("→ No token or expired token, redirecting to login…");
        localStorage.removeItem("token");
        window.location.href = '/';
        throw new Error("Redirecting to login…");
    }
    return tok;
}
/** Convenience wrapper: return username from the JWT (or null). */
function currentUsername() {
    const tok = getToken();
    if (!tok)
        return null;
    try {
        const { username } = decodeJwt(tok);
        return username ?? null;
    }
    catch {
        return null;
    }
}
function currentUsernames() {
    const tok = getToken();
    if (!tok)
        return null;
    try {
        const parts = tok.split(".");
        if (parts.length !== 3)
            return null;
        let b64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
        b64 = b64.padEnd(Math.ceil(b64.length / 4) * 4, "=");
        const jsonText = atob(b64);
        const payload = JSON.parse(jsonText);
        return payload.username ?? null;
    }
    catch {
        return null;
    }
}
/** Remove the JWT from LocalStorage */
function removeToken() {
    try {
        callStorage('removeItem', 'token');
    }
    catch (err) {
        console.warn("Failed to remove token:", err);
    }
}

export { currentUsername, currentUsernames, getAuthorizationHeader, getToken, isLoggedIn, removeToken, requireToken };
//# sourceMappingURL=token_utils.js.map
